import React from 'react';
import styled from 'styled-components';
import Layout from './Layout';
import { colors } from '../styles/colors';

const StatusContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: 64px 32px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 32px 24px;
  }
`;

const IconCircle = styled.div`
  width: 80px;
  height: 80px;
  margin: 0 auto 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid ${colors.primary};
`;

const CheckmarkSvg = styled.svg`
  width: 48px;
  height: 48px;
  stroke: ${colors.primary};
  stroke-width: 3;
  fill: none;
`;

const StatusTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  color: ${colors.text};
`;

const StatusMessage = styled.p`
  font-size: 14px;
  color: ${colors.textLight};
`;

const CompletePage = () => {
  return (
    <Layout>
      <StatusContainer>
        <IconCircle>
          <CheckmarkSvg viewBox="0 0 52 52">
            <path d="M14 27l7.5 7.5L38 18" />
          </CheckmarkSvg>
        </IconCircle>
        <StatusTitle>リアクションが送信されました</StatusTitle>
        <StatusMessage>この画面は閉じてください。</StatusMessage>
      </StatusContainer>
    </Layout>
  );
};

export default CompletePage;
